// Usage Chart - 12-month bar visualization for electricity usage

import { MONTH_LABELS, isSummerMonth } from '@/utils/planCalculations';

interface UsageChartProps {
  usageArray: number[];
  maxBarHeight?: number;
}

export function UsageChart({ usageArray, maxBarHeight = 60 }: UsageChartProps) {
  if (!usageArray || usageArray.length !== 12) {
    return null;
  }

  const maxUsage = Math.max(...usageArray);

  return (
    <div className="usage-chart">
      <div className="usage-chart__bars">
        {usageArray.map((usage, index) => {
          const heightPx = maxUsage > 0 ? Math.round((usage / maxUsage) * maxBarHeight) : 4;
          const isSummer = isSummerMonth(index);

          return (
            <div key={index} className="usage-chart__bar-container">
              <div
                className={`usage-chart__bar ${isSummer ? 'usage-chart__bar--summer' : ''}`}
                style={{ height: `${heightPx}px` }}
                data-tooltip={`${usage.toLocaleString()} kWh`}
                title={`${MONTH_LABELS[index]}: ${usage.toLocaleString()} kWh`}
              />
              <div className="usage-chart__label">{MONTH_LABELS[index]}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
